import { useLocation } from 'react-router-dom';
import { slimTier, paramsAdd, paramsEdit } from '../constants/form';
import { useSelector } from 'react-redux';
import { routes } from '../constants/routes';

export const useAutologinIBV = () => {
  const isLoginIbv = useLocation()?.pathname.includes('login-ibv')
  const { last_regular_tier } = useSelector(state => state?.personData?.data) || {}
  const currentParam = last_regular_tier?.unique_name === slimTier ? paramsEdit : paramsAdd
  
  /* Route for tier slim, action 'add' */
  const slim = routes.tier(slimTier, currentParam)
  return {
    isLoginIbv,
    slim
  }
}

